import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import type { Product } from '../data/products';
type MaterialCatalogCardProps = {
  product: Product;
  categoryName: string;
  isBestSeller: boolean;
  index: number;
};
export function MaterialCatalogCard({
  product,
  categoryName,
  isBestSeller,
  index
}: MaterialCatalogCardProps) {
  return <motion.div layout initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.22,
    delay: Math.min(index, 5) * 0.035
  }} data-id="element-1283" data-mp="24i1j849j9owp">
      <Link to={`/shop/${product.slug}`} className="group relative block h-44 overflow-hidden rounded-xl border border-stone-200 bg-stone-200 shadow-sm transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-[#04A05C] focus-visible:ring-offset-2 hover:shadow-md sm:h-40 dark:border-white/10 dark:bg-white/10 dark:focus-visible:ring-offset-[#131413]" aria-label={`View ${product.name}, from ${product.pricePerYard} per yard`} data-id="element-1284" data-mp="20j2eokrpru5s">
        <img src={product.images?.[0] || product.image} alt="" loading={index < 3 ? 'eager' : 'lazy'} decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" data-id="element-1285" data-mp="2wfap1q8i2meu" />
        {isBestSeller && <span className="absolute left-0 top-4 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide shadow-sm text-[#ffff9] bg-[#006239]" data-id="element-1286" data-mp="3a5mjhvsk4x95">Best Seller</span>}
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 bg-white px-3 py-2.5 text-stone-950 sm:px-4 dark:bg-black/65 dark:text-white dark:backdrop-blur-[2px]" data-id="element-1287" data-mp="3f47jpv7t7gxl">
          <div className="min-w-0 font-sub" data-id="element-1288" data-mp="3p3exgjighdl8">
            <p className="truncate text-[9px] font-bold uppercase tracking-[0.12em] text-stone-500 dark:text-white/70" data-id="element-1289" data-mp="3t4ia6x57iti8">{categoryName}</p>
            <h3 className="mt-0.5 truncate text-sm font-bold leading-tight sm:text-base" data-id="element-1290" data-mp="1upxhpioall0r">{product.name}</h3>
          </div>
          <p className="shrink-0 font-sub text-base font-bold" data-id="element-1291" data-mp="1yqzgxzi7lx2q">${product.pricePerYard}<span className="ml-0.5 text-xs font-semibold text-stone-500 dark:text-white/75" data-id="element-1292" data-mp="322g1kqzlxf0w">/yd</span></p>
        </div>
      </Link>
    </motion.div>;
}